/** Namespaced localStorage helper (keys prefixed `phponl_`, JSON-encoded).
 * Safe against quota/parse errors. */
export const LS = {
  get<T>(key: string, fallback: T): T {
    try {
      const v = localStorage.getItem('phponl_' + key);
      return v == null ? fallback : (JSON.parse(v) as T);
    } catch {
      return fallback;
    }
  },
  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem('phponl_' + key, JSON.stringify(value));
    } catch {
      /* ignore quota/serialisation errors */
    }
  },
};
